/**
 * Web / default stub for the native code highlighter.
 *
 * Metro resolves hljsHighlighter.native.jsx on ios/android/macos and this file
 * everywhere else, which is what keeps highlight.js and its 38 language
 * definitions (~315 KB gzip) out of the web bundle. See the header comment in
 * the .native sibling for why a runtime Platform check could not do this.
 *
 * MessageContentRenderer only calls into this on non-web platforms, so the
 * fallback below is defensive rather than a real rendering path. Web code blocks
 * go through WebSyntaxHighlighter, which lazily imports
 * react-native-syntax-highlighter as its own async chunk.
 */

export function highlightCodeNative(code) {
  return code;
}

export default highlightCodeNative;
